import React from "react";
import Lottie from "react-lottie";

export default function LottieAnimation({ lotti, width, height, message }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lotti,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Lottie options={defaultOptions} height={height} width={width} />
      {/* <span className="fs--1" style={{ fontWeight: "400" }}> */}
      {message && <h6 className="text-success">{message}</h6>}

      {/* </span> */}
    </div>
  );
}
